import type {
  BatchEditSelectProperties,
  ObservationsBatchEditPropertyKey,
} from "./observations-batch-edit.type";
import type { ObservationLite } from "@/entities/observation";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useDisableBatchTransition } from "@/modules/batch-transition";

export const useObservationsBatchEditProperties = (
  observations: ObservationLite[]
) => {
  const { t } = useTranslation();
  const state = useDisableBatchTransition("observation", observations);
  const isSeverityUpdateActivated = useFeatureFlag(
    "batchUpdateObservationSeverity"
  );

  const [currentProperty, setCurrentProperty] =
    useState<ObservationsBatchEditPropertyKey | null>(null);

  const properties: BatchEditSelectProperties = [
    {
      value: "state",
      label: t("observation:batchEdit.state.optionTitle"),
      disabled: state.disabled,
      tooltip: state.tooltip,
    },
    {
      value: "severity",
      hidden: !isSeverityUpdateActivated,
      label: t("observation:batchEdit.severity.optionTitle"),
    },
  ];

  return {
    properties,
    currentProperty,
    setCurrentProperty,
  };
};
